import { Text, Card } from 'braid-design-system';
import React from 'react';

const Disclaimer = () => (
  <Card>
    <Text tone="secondary">
      The results from this price guide are based on SEEK Business data and
      should be used as an indication only. This is not a professional
      valuation. For further advice, consult a finance professional.
    </Text>
  </Card>
);

export default Disclaimer;
